import { useState, useEffect } from 'react'
import { api } from '../lib/api'
import { Empty } from '../components/UI'

export default function Changelog() {
  const [releases, setReleases] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    api.getChangelog().then(d => setReleases(Array.isArray(d) ? d : [])).catch(() => setReleases([])).finally(() => setLoading(false))
  }, [])

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <div className="toolbar">
        <div className="toolbar-left">
          <span className="toolbar-title">📢 What's New</span>
          <span className="toolbar-sub">{releases.length} release{releases.length !== 1 ? 's' : ''}</span>
        </div>
      </div>
      <div style={{ flex: 1, overflow: 'auto', padding: 24, maxWidth: 760 }}>
        {loading ? <Empty icon="⏳" title="Loading..." />
          : releases.length === 0 ? <Empty icon="📢" title="No releases yet" sub="Version history will appear here after deployments." />
            : releases.map((r, i) => (
              <div key={r.version} style={{ marginBottom: 28, position: 'relative', paddingLeft: 20, borderLeft: i === releases.length - 1 ? 'none' : '2px solid var(--border)' }}>
                <div style={{ position: 'absolute', left: -7, top: 4, width: 12, height: 12, borderRadius: '50%', background: i === 0 ? 'var(--accent)' : 'var(--border2)', border: '2px solid var(--bg)' }} />
                <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 4 }}>
                  <span style={{ fontSize: 18, fontWeight: 700, color: 'var(--text)' }}>{r.version}</span>
                  {i === 0 && <span style={{ fontSize: 10, fontWeight: 700, color: '#fff', background: 'var(--accent)', borderRadius: 12, padding: '2px 8px', letterSpacing: 0.5 }}>LATEST</span>}
                  <span style={{ fontSize: 12, color: 'var(--text3)', fontFamily: 'DM Mono, monospace' }}>{r.date}</span>
                </div>
                {(!r.changes || r.changes.length === 0)
                  ? <div style={{ fontSize: 13, color: 'var(--text3)', fontStyle: 'italic' }}>Minor updates and fixes.</div>
                  : <ul style={{ margin: '8px 0 0', paddingLeft: 18 }}>
                    {r.changes.map((c, j) => (
                      <li key={j} style={{ fontSize: 13.5, color: 'var(--text2)', marginBottom: 6, lineHeight: 1.5 }}>{c}</li>
                    ))}
                  </ul>}
              </div>
            ))}
      </div>
    </div>
  )
}
